import { useNavigate } from "react-router-dom";
import ExternalLink from "../../../../assets/svg/External_Link.svg";

const ServicesSupport = ({ openServices, sSubManuItem, setSSubManuItem, subMenuWidth, closeAllManu, height }) => {
  const navigate = useNavigate();
  return (
    <div
      onMouseEnter={() => openServices()}
      onMouseLeave={() => closeAllManu()}
      className={`absolute z-[10001]`}
      style={{ left: `${subMenuWidth.offsetLeft - 305}px` }}
    >
      <div className="mr-[33px]" style={{ top: `${height}px`, width: `${subMenuWidth.offsetWidth + 305}px` }}>
        <div className="bg-[#F2F2F2]">
          <div className="grid grid-cols-4 gap-4">
            <div className="col-span-1 border-r-[1px] border-r-[#292929]">
              <div className="border-b-[1px] border-b-black py-[8px] cursor-pointer">
                <div
                  className={`${sSubManuItem == "GASOLINE" ? "border-l-[#7ABF5B] font-bold" : "border-l-[#292929] font-normal"
                    }  text-[20px] font-[Roboto] text-[#000] border-l-[11px] px-[34px] py-[26px]`}
                  onMouseEnter={() => setSSubManuItem("GASOLINE")}
                >
                  GASOLINE
                </div>
              </div>

              <div className="border-b-[1px] border-b-black py-[8px] cursor-pointer">
                <div
                  className={`${sSubManuItem == "ELECTRIC" ? "border-l-[#7ABF5B] font-bold" : "border-l-[#292929] font-normal"
                    }  text-[20px] font-[Roboto] text-[#000] border-l-[11px] px-[34px] py-[26px]`}
                  onMouseEnter={() => setSSubManuItem("ELECTRIC")}
                >
                  ELECTRIC
                </div>
              </div>
            </div>

            {sSubManuItem == "GASOLINE" ? (
              <div className="col-span-3 mx-[47px]">
                <div className="pt-[35px] pb-[25px] border-b-[1px] border-b-[#292929] font-bold text-[20px] font-[Roboto] text-[#000]">
                  Tuatara USA Warranty 2024
                </div>
                <div className="flex mt-[41px]">
                  {/* Left Side - Auto Width */}
                  <div className="flex-grow col-span-3  ">
                    <div
                      className="font-bold text-[20px] font-[Roboto] text-[#000]  pb-[33px]"
                    // onClick={() => {
                    //   window.scrollTo(0, 0);
                    //   navigate("#");
                    //   closeAllManu();
                    // }}
                    >
                      Gasoline 1000EFI
                    </div>

                    <ul class="list-disc ml-[22px]">
                      <li className="font-normal text-[20px] font-[Roboto] text-[#000]  pb-[33px]">
                        Now this is a story all about how, my life got flipped-turned upside down
                      </li>
                      <li className="font-normal text-[20px] font-[Roboto] text-[#000]  pb-[33px]">
                        Standard (Included):  Vehicle Drive Train Warranty 12 months or 15,000 miles
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : null}

            {sSubManuItem == "ELECTRIC" ? (
              <div className="col-span-3 mx-[47px]">
                <div className="pt-[35px] pb-[25px] border-b-[1px] border-b-[#292929] font-bold text-[20px] font-[Roboto] text-[#000]">
                  Tuatara USA Warranty 2024
                </div>
                <div className="flex mt-[41px]">
                  {/* Left Side - Auto Width */}
                  <div className="flex-grow col-span-3  ">
                    <div
                      className="font-bold text-[20px] font-[Roboto] text-[#000]  pb-[33px]"
                    // onClick={() => {
                    //   window.scrollTo(0, 0);
                    //   navigate("#");
                    //   closeAllManu();
                    // }}
                    >
                      Electric 1500E, SC2500E, SC2300E
                    </div>

                    <ul class="list-disc  ml-[22px]">
                      <li className="font-normal text-[20px] font-[Roboto] text-[#000] pb-[33px]">
                        Standard (Included): Vehicle Parts 90 days or 3,000 miles
                      </li>
                      <li className="font-normal text-[20px] font-[Roboto] text-[#000]  pb-[33px]">
                        Standard (Included):  Vehicle Drive Train Warranty 12 months or 15,000 miles
                      </li>
                      <li className="font-normal text-[20px] font-[Roboto] text-[#000]  pb-[33px]">
                        Battery Warranty: 5 years or 1000 cycles
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ServicesSupport;
